import { useState } from 'react';
import axios from 'axios';
import { useToast } from './use-toast';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const useContactForm = () => {
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const response = await axios.post(`${BACKEND_URL}/api/contact`, formData);
      
      if (response.data.success) {
        toast({
          title: 'Message Sent Successfully! ✓',
          description: response.data.message,
        });
        // Reset form
        setFormData({ name: '', email: '', mobile: '', subject: '', message: '' });
      }
    } catch (error) {
      // Log error in development only
      if (process.env.NODE_ENV === 'development') {
        console.error('Error sending message:', error);
      }
      toast({
        title: 'Error Sending Message',
        description: error.response?.data?.detail || 'Failed to send message. Please try again or contact us directly.',
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    loading,
    handleChange,
    handleSubmit,
  };
};
